import { Plane, Building2, Car, Cross } from "lucide-react";

const Background = () => {
    return (
        <div className="absolute inset-0 opacity-15">
                {/* Airplane icons */}
                <div className="absolute top-16 left-[10%] w-16 h-16">
                  <Plane className="w-full h-full text-white rotate-45" />
                </div>
                <div className="absolute top-32 right-[15%] w-12 h-12">
                  <Plane className="w-full h-full text-white -rotate-12" />
                </div>
                <div className="absolute bottom-32 left-[5%] w-14 h-14">
                  <Plane className="w-full h-full text-white rotate-[30deg]" />
                </div>
                <div className="absolute top-[60%] right-[8%] w-10 h-10">
                  <Plane className="w-full h-full text-white rotate-[60deg]" />
                </div>
        
                {/* Hotel/Building icons */}
                <div className="absolute top-24 left-[30%] w-14 h-14">
                  <Building2 className="w-full h-full text-white" />
                </div>
                <div className="absolute bottom-20 right-[25%] w-12 h-12">
                  <Building2 className="w-full h-full text-white" />
                </div>
                <div className="absolute top-[45%] left-[3%] w-10 h-10">
                  <Building2 className="w-full h-full text-white" />
                </div>
        
                {/* Car icons */}
                <div className="absolute top-20 right-[35%] w-12 h-12">
                  <Car className="w-full h-full text-white" />
                </div>
                <div className="absolute bottom-28 left-[20%] w-14 h-14">
                  <Car className="w-full h-full text-white" />
                </div>
                <div className="absolute top-[55%] right-[3%] w-10 h-10">
                  <Car className="w-full h-full text-white" />
                </div>
        
                {/* Assistance/Cross icons */}
                <div className="absolute top-12 left-[50%] w-10 h-10">
                  <Cross className="w-full h-full text-white" />
                </div>
                <div className="absolute bottom-16 right-[40%] w-12 h-12">
                  <Cross className="w-full h-full text-white" />
                </div>
                <div className="absolute top-[70%] left-[15%] w-8 h-8">
                  <Cross className="w-full h-full text-white" />
                </div>
                <div className="absolute bottom-[45%] right-[18%] w-10 h-10">
                  <Cross className="w-full h-full text-white" />
                </div>
              </div>
    )
}

export default Background;